import React from "react";
import { Link } from "react-router-dom";
import PolicyPage, { POLICY_ADDRESS, PolicyEmail } from "./PolicyPage";

function Terms() {
  return (
    <PolicyPage
      title="Terms of service"
      intro="These terms govern use of the slayfulpawsco storefront and purchases made through it. Mandatory consumer rights that apply to you remain unaffected."
    >
      <h2>Agreement and eligibility</h2>
      <p>
        By using this site or submitting an order, you agree to these terms and
        the policies incorporated by reference. You must be legally able to
        enter into the transaction or use the site with permission from a
        parent or legal guardian.
      </p>

      <h2>Store information</h2>
      <p>
        We aim to keep product descriptions, availability, dimensions,
        materials, colors, images, and prices accurate. Screens and lighting can
        display colors differently, and handmade or natural materials may have
        minor variations. We may correct a genuine error before accepting an
        order and will offer an appropriate cancellation or refund if a
        material error affects an accepted order.
      </p>

      <h2>Orders and contract formation</h2>
      <p>
        An order submission is an offer to purchase. An automated receipt only
        acknowledges submission. Acceptance occurs when we send an express
        acceptance or dispatch confirmation, unless mandatory law provides
        otherwise. We may set reasonable quantity limits and reject or cancel
        an order for unavailability, an obvious pricing error, suspected fraud,
        payment failure, delivery restrictions, or unlawful activity.
      </p>
      <p>
        The <Link to="/orders">Order and Cancellation Policy</Link>,
        <Link to="/payments"> Payment Policy</Link>, and
        <Link to="/pricing"> Pricing, Tax and Customs Policy</Link> form part of
        these terms.
      </p>

      <h2>Shipping, returns, and refunds</h2>
      <p>
        Delivery, title, and risk are governed by the information confirmed for
        the order and applicable law. Our <Link to="/shipping">Shipping
        Policy</Link> and <Link to="/returns">Return and Refund Policy</Link>
        explain the standard process. They do not limit non-waivable rights.
      </p>

      <h2>Promotions</h2>
      <p>
        A promotion may have separate eligibility, timing, product, or
        redemption terms. Unless stated otherwise, offers cannot be combined,
        transferred, redeemed for cash, or applied after an order is placed. We
        may correct misuse or a technical error while honoring rights already
        required by law.
      </p>

      <h2>Permitted use</h2>
      <p>
        You may use the site for lawful personal shopping and communication.
        You must not interfere with its security or operation, submit false
        information, use another person’s payment method without authority,
        introduce harmful code, or violate another person’s rights. Additional
        details appear in our <Link to="/acceptable-use">Acceptable Use
        Policy</Link>.
      </p>

      <h2>Intellectual property</h2>
      <p>
        The slayfulpawsco name, original text, original graphics, site
        arrangement, and other original materials are protected by applicable
        intellectual-property laws. Third-party names and rights belong to
        their owners. No use of a third-party name implies sponsorship or
        affiliation. See our <Link to="/intellectual-property">Intellectual
        Property and Rights Policy</Link>.
      </p>

      <h2>Third-party services and links</h2>
      <p>
        Payment, delivery, fonts, hosting, and other features may be supplied by
        independent providers. Their terms and notices may apply when you use
        those services. We are not responsible for an unrelated third-party
        site merely because this site links to it, but this does not limit our
        responsibility for providers acting on our behalf where the law makes
        us responsible.
      </p>

      <h2>Disclaimers and liability</h2>
      <p>
        To the extent permitted by law, the site is provided on an “as
        available” basis and we do not guarantee uninterrupted or error-free
        access. We are not responsible for losses that are indirect,
        unforeseeable, or caused solely by events outside reasonable control.
        Nothing in these terms excludes liability or a remedy that cannot
        lawfully be excluded, including applicable rights concerning defective
        goods, fraud, or personal injury caused by negligence.
      </p>

      <h2>Changes, severability, and applicable law</h2>
      <p>
        The terms in effect when an order is accepted generally govern that
        order. We may update site-use terms prospectively by posting a revised
        version. If one provision is unenforceable, the remaining provisions
        continue to the extent allowed. Applicable law and forum are determined
        under ordinary conflict-of-law and consumer-protection rules; these
        terms do not take away mandatory protections or a forum available to
        you by law.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about these terms may be sent to
        <PolicyEmail subject="Terms of service question" />.
      </p>
      <p><strong>Mailing address:</strong> {POLICY_ADDRESS}</p>
    </PolicyPage>
  );
}

export default Terms;
